module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/icon_train-77db817b3a6fce9d195a6f4a1b3d83d7.svg";